export default "__VITE_ASSET__ece7a985__"